export const CUSTOMER_STATUS = {
    LOADING: 'loading',
    ERROR: 'error',
    AUTHENTICATED: 'authenticated',
    UNAUTHENTICATED: 'unauthenticated',
} as const;
